import script from "./OrderStatusVisibleButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderStatusVisibleButton.vue?vue&type=script&setup=true&lang=ts"

import "./OrderStatusVisibleButton.vue?vue&type=style&index=0&id=e7820830&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7820830"]])

export default __exports__